import { SUFFIXE_MAIL_DEFAULT } from '../userCreateHelpers';
import { UserOnHome } from '../../../types/user/user.def';

const notUpdatedMail = mail => mail.match(SUFFIXE_MAIL_DEFAULT);

export const errEleveInfos = (eleve: UserOnHome): boolean => {
  if (process.env.NODE_ENV === 'development')
    eleve = { ...eleve, avatar: { media: { url: ' ' } } };
  if (
    !eleve.tel ||
    !eleve.lastname ||
    !eleve.firstname ||
    !eleve.email ||
    !eleve.avatar?.media?.url ||
    notUpdatedMail(eleve.email)
  )
    return true;
};

export const displayErrEleveInfos = (eleve: UserOnHome): any => {
  return {
    tel: !eleve.tel,
    lastname: !eleve.lastname,
    firstname: !eleve.firstname,
    email: !eleve.email,
    avatar: !eleve.avatar?.media?.url,
    updatedMail: notUpdatedMail(eleve.email)
  };
};
